import { Box, Divider, Tooltip } from "@mui/material";
import {
  getCurrencyFromSetup,
  getEventTotalValue,
} from "../../../common/EntitiesManagement";
import { getValueInCurrency } from "../../../common/utils";
import ValueOrNoDataLabel from "../../../components/common/ValueOrNoDataLabel";
import { DragHandle, TrendingDown, TrendingUp } from "@mui/icons-material";
import localize from "../../../common/localize";

export default function RealIncomeValue({ eventModel }) {
  const getWinOrLooseIcon = () => {
    if (eventModel?.realIncome > 0) {
      return <TrendingUp sx={{ color: "green" }} />;
    }

    if (eventModel?.realIncome < 0) {
      return <TrendingDown sx={{ color: "red" }} />;
    }

    return <DragHandle />;
  };

  return (
    <Box className="flex gap-2 items-center w-full justify-between">
      {getWinOrLooseIcon()}
      <ValueOrNoDataLabel
        data={getValueInCurrency(
          getCurrencyFromSetup(),
          eventModel?.realIncome ?? 0,
        )}
      />
    </Box>
  );
}
